import { Injectable, computed, signal } from '@angular/core';

/**
 * Indicador de carga global.
 *
 * Antes era un `Subject<boolean>` que cada componente encendia y apagaba a mano
 * alrededor de sus llamadas HTTP. Ese patron deja el indicador colgado en
 * cuanto una rama de error se olvida de apagarlo, y era exactamente lo que
 * pasaba en el flujo antiguo.
 *
 * Ahora lo mueve `loadingInterceptor` contando peticiones en vuelo, asi que
 * nadie tiene que acordarse. `retener()` queda para el caso que el interceptor
 * no cubre: un trabajo largo del navegador, como la compresion de imagenes de
 * SPEC-006, que no es una peticion HTTP.
 */
@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly enVuelo = signal(0);

  readonly cargando = computed(() => this.enVuelo() > 0);

  /** Marca el inicio de un trabajo. Devuelve la funcion que lo cierra. */
  retener(): () => void {
    this.enVuelo.update((n) => n + 1);

    let liberado = false;
    return () => {
      if (liberado) return; // idempotente: liberar dos veces no descuadra el contador
      liberado = true;
      this.enVuelo.update((n) => Math.max(0, n - 1));
    };
  }
}
